const DOW_NAMES = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

function pad(n: number): string {
  return n.toString().padStart(2, "0");
}

function describeDow(dow: string): string | null {
  if (dow === "1-5") return "weekdays";
  if (dow === "0,6" || dow === "6,0" || dow === "0,7") return "weekends";
  const names: string[] = [];
  for (const part of dow.split(",")) {
    const n = Number(part);
    if (!Number.isInteger(n) || n < 0 || n > 7) return null;
    names.push(DOW_NAMES[n === 7 ? 0 : n]);
  }
  return names.join(", ");
}

export function describeCron(expr: string): string | null {
  const tokens = expr.trim().split(/\s+/);
  if (tokens.length !== 5) return null;
  const [min, hour, dom, month, dow] = tokens;

  const minInterval = min.match(/^\*\/(\d+)$/);
  if (minInterval && hour === "*" && dom === "*" && month === "*" && dow === "*") {
    const n = Number(minInterval[1]);
    return n === 1 ? "Every minute" : `Every ${n} minutes`;
  }

  const hourInterval = hour.match(/^\*\/(\d+)$/);
  if (/^\d+$/.test(min) && hourInterval && dom === "*" && month === "*" && dow === "*") {
    const n = Number(hourInterval[1]);
    const base = n === 1 ? "Every hour" : `Every ${n} hours`;
    return Number(min) === 0 ? base : `${base} at :${pad(Number(min))}`;
  }

  if (!/^\d+$/.test(min)) return null;
  const minute = Number(min);
  if (minute > 59) return null;

  if (hour === "*" && dom === "*" && month === "*" && dow === "*") {
    return minute === 0 ? "Every hour" : `Every hour at :${pad(minute)}`;
  }

  if (!/^\d+$/.test(hour)) return null;
  const h = Number(hour);
  if (h > 23) return null;
  const time = `${pad(h)}:${pad(minute)}`;

  if (dom === "*" && month === "*" && dow !== "*") {
    const days = describeDow(dow);
    if (!days) return null;
    if (days === "weekdays") return `Every weekday at ${time}`;
    if (days === "weekends") return `Every weekend at ${time}`;
    return `Every ${days} at ${time}`;
  }

  if (/^\d+$/.test(dom) && month === "*" && dow === "*") {
    return `Monthly on day ${Number(dom)} at ${time}`;
  }

  if (dom === "*" && month === "*" && dow === "*") {
    return `Every day at ${time}`;
  }

  return null;
}
